import { useCallback, useEffect, useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import InstallingSplashScreen from './InstallingScreen/InstallingSplashScreen/InstallingSplashScreen'
import AppRoot from './AppRoot'

function hasSubdomain(url: URL): boolean {
    const hostParts = url.hostname.split('.')
    return hostParts.length > 2 && hostParts[0] !== 'www'
}

function SWAppReload() {
    const [isReInstalling, setIsReInstalling] = useState<
        'IDLE' | 'SHOW' | 'ERROR'
    >('IDLE')
    const intervalMS = 60 * 60 * 1000 // 1 hour
    const shouldRegisterSW =
        hasSubdomain(new URL(window.location.href)) &&
        !window.location.pathname.startsWith('/register')

    useRegisterSW({
        immediate: true,
        onRegisteredSW(swUrl, registration) {
            console.log(`Service Worker at: ${swUrl}`)

            if (!shouldRegisterSW) {
                // Unregister the service worker if the URL does not have a subdomain
                registration &&
                    registration.unregister().then(() => {
                        console.log(
                            'Service worker unregistered due to no subdomain',
                        )
                    })
            }

            // try to update service worker every hour if there is a new version
            registration &&
                setInterval(async () => {
                    if (!(!registration.installing && navigator)) return

                    if ('connection' in navigator && !navigator.onLine) return

                    try {
                        const response = await fetch(swUrl, {
                            cache: 'no-store',
                            headers: {
                                cache: 'no-store',
                                'cache-control': 'no-cache',
                            },
                        })
                        if (response.status === 200) {
                            await registration.update()
                        }
                    } catch (error: any) {
                        // This will handle errors from both 'fetch(...)' and 'registration.update()'
                        console.error(error.message)
                    }
                }, intervalMS)

            /**
             * If it false; Install service-worker at the first-time.
             */
            const isActive = !!registration?.active

            if (registration) {
                registration.onupdatefound = () => {
                    const installingWorker = registration.installing
                    if (installingWorker) {
                        if (isActive) setIsReInstalling('SHOW')

                        installingWorker.onstatechange = (event) => {
                            console.log(
                                'onstatechange: ',
                                installingWorker.state,
                            )
                            console.log('onstatechange event event: ', event)

                            if (!shouldRegisterSW) {
                                // Unregister the service worker if the URL does not have a subdomain
                                registration.unregister().then(() => {
                                    console.log(
                                        'Service worker unregistered due to no subdomain',
                                    )
                                })
                            }
                        }
                    }
                }
            }
        },
        onRegisterError(error) {
            console.error('SW registration error', error)
            setIsReInstalling('ERROR')
        },
    })

    useEffect(() => {
        // Unregister old service-worker of this Project, Will remove this code when go a while
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker
                .getRegistrations()
                .then(function (registrations) {
                    // Loop through all the service workers
                    for (let registration of registrations) {
                        // Check if this is the service worker you want to unregister
                        console.log(
                            'unregister scriptURL scriptURL scriptURL: ',
                            registration.active?.scriptURL,
                        )
                        if (
                            registration.active?.scriptURL.endsWith(
                                '/service-worker.js',
                            )
                        ) {
                            // Unregister the service worker
                            registration.unregister().then(function () {
                                console.log('Service worker unregistered')
                            })

                            // Break out of the loop since we found the service worker to unregister
                            break
                        }
                    }
                })
        }
    }, [])

    // useEffect(() => {
    //     if (!hasSubdomain(new URL(window.location.href))) {
    //         // Unregister the service worker if the URL does not have a subdomain
    //         if ('serviceWorker' in navigator) {
    //             navigator.serviceWorker
    //                 .getRegistrations()
    //                 .then((registrations) => {
    //                     registrations.forEach((registration) => {
    //                         registration.unregister().then(() => {
    //                             console.log(
    //                                 'Service worker unregistered due to no subdomain',
    //                             )
    //                         })
    //                     })
    //                 })
    //         }
    //     }
    // }, [])

    const isShow = isReInstalling !== 'IDLE'

    const onRefresh = useCallback(() => {
        window.location.reload()
    }, [])

    const [displayInstalling, setDisplayInstalling] = useState(false)

    useEffect(() => {
        if (isShow) {
            setDisplayInstalling(true)
            const timer = setTimeout(() => {
                onRefresh()
            }, 30000) // refresh page after 30 seconds if service worker is not activated
            return () => {
                clearTimeout(timer)
            }
        }
    }, [isShow, onRefresh])

    return (
        <>
            {displayInstalling ? (
                <InstallingSplashScreen isNewVersion />
            ) : (
                <AppRoot />
            )}
        </>
    )
}

export default SWAppReload
